import { render, staticRenderFns } from "./PersonhandSvg.vue?vue&type=template&id=ca3c0e2a&"
import script from "./PersonhandSvg.vue?vue&type=script&lang=js&"
export * from "./PersonhandSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports